import { render } from "./AssistantQuickQuestionsEditor.vue?vue&type=template&id=98b10352&scoped=true"
import script from "./AssistantQuickQuestionsEditor.vue?vue&type=script&lang=js"
export * from "./AssistantQuickQuestionsEditor.vue?vue&type=script&lang=js"

import "./AssistantQuickQuestionsEditor.vue?vue&type=style&index=0&id=98b10352&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98b10352"]])

export default __exports__